// Define styles for each specific combination
export const buttonStyleMap = {
  // Primary variants - enabled
  'primary-normal-enabled':
    'bg-brand-primary text-white border dark:border-brand border-[var(--brand-700)] hover:bg-brand-primary-hover',
  'primary-outlined-enabled':
    'bg-transparent text-brand-secondary border dark:border-brand border-brand-strong hover:text-brand-tertiary hover:bg-brand-tertiary hover:border-brand',
  'primary-plain-enabled':
    'bg-transparent text-brand-secondary border border-transparent hover:bg-brand-tertiary',
  // Primary and secondary underlined variants are the same
  'primary-underlined-enabled':
    'bg-primary text-primary border-b dark:border-b-primary border-b-black hover:border-b-brand-strong hover:dark:border-b-brand-strong hover:text-brand-secondary',

  // Primary variants - disabled
  'primary-normal-disabled':
    'bg-brand-tertiary border border-transparent text-brand-disabled',
  'primary-outlined-disabled':
    'bg-transparent text-brand-disabled border border-[var(--border-brand-100)]',
  'primary-plain-disabled': 'bg-transparent text-brand-disabled',
  'primary-underlined-disabled':
    'bg-primary text-brand-disabled border-transparent border-b border-b-[var(--border-brand-100)]',

  // Secondary variants - enabled
  'secondary-normal-enabled':
    'bg-primary text-primary border dark:border-[var(--gray-200)] border-secondary hover:bg-secondary',
  'secondary-outlined-enabled':
    'bg-primary text-primary border dark:border-[var(--gray-200)] border-secondary hover:bg-secondary',
  'secondary-plain-enabled':
    'bg-primary text-primary border border-transparent hover:bg-secondary-hover',
  'secondary-underlined-enabled':
    'bg-primary text-primary border-b dark:border-b-primary border-b-black hover:border-b-brand-strong hover:dark:border-b-brand-strong hover:text-brand-secondary',

  // Secondary variants - disabled
  'secondary-normal-disabled':
    'bg-quaternary border border-transparent text-disabled',
  'secondary-outlined-disabled':
    'bg-primary text-disabled border-tertiary border',
  'secondary-plain-disabled': 'bg-primary text-disabled',
  'secondary-underlined-disabled':
    'bg-primary text-disabled border-transparent border-b border-b-tertiary',

  // Error variants - enabled
  'error-normal-enabled':
    'bg-error-strong dark:bg-error-secondary text-white border border-red-600 hover:bg-error-strong-hover dark:hover:bg-error-primary',
  'error-outlined-enabled':
    'bg-transparent text-error border border-red-700 hover:bg-error-primary',
  'error-plain-enabled':
    'bg-transparent text-error border border-transparent hover:bg-error-primary',
  'error-underlined-enabled':
    'bg-primary text-primary border-b dark:border-b-primary border-b-black hover:border-b-error-strong hover:dark:border-b-error-strong hover:text-error',

  // Error variants - disabled
  'error-normal-disabled':
    'bg-error-primary border border-transparent text-[var(--red-300)]',
  'error-outlined-disabled':
    'bg-transparent text-[var(--red-300)] border border-[var(--red-100)]',
  'error-plain-disabled': 'bg-transparent text-[var(--red-300)]',
  'error-underlined-disabled':
    'bg-primary text-error-disabled border-transparent border-b border-b-[var(--border-error-100)]',
};
